export const checkStorage = async (): Promise<boolean> => {
  const testKey = 'storage_availability_test';
  const testValue = 'test';
  const localStorageAvailable = (() => {
    try {
      localStorage.setItem(testKey, testValue);
      const stored = localStorage.getItem(testKey);

      if (stored !== testValue) {
        throw new Error('localStorage readback mismatch');
      }

      localStorage.removeItem(testKey);

      return true;
    } catch (error) {
      return false;
    }
  })();

  const indexedDBAvailable = await new Promise<boolean>((resolve) => {
    try {
      const dbName = 'indexedDB_availability_test';
      const storeName = 'test_store';
      const request = indexedDB.open(dbName, 1);

      // Create object store
      request.onupgradeneeded = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        db.createObjectStore(storeName);
      };

      request.onsuccess = () => {
        const db = request.result;

        try {
          // Write test value
          const tx = db.transaction(storeName, 'readwrite');
          tx.objectStore(storeName).put(testValue, testKey);

          // Read it back
          const readTx = db.transaction(storeName, 'readonly');
          const readRequest = readTx.objectStore(storeName).get(testKey);

          readRequest.onsuccess = () => {
            const isValid = readRequest.result === testValue;
            db.close();
            indexedDB.deleteDatabase(dbName);
            resolve(isValid);
          };

          readRequest.onerror = () => {
            db.close();
            indexedDB.deleteDatabase(dbName);
            resolve(false);
          };
        } catch (error) {
          db.close();
          indexedDB.deleteDatabase(dbName);
          resolve(false);
        }
      };

      request.onerror = () => resolve(false);
      request.onblocked = () => resolve(false);
    } catch (error) {
      resolve(false);
    }
  });

  return localStorageAvailable && indexedDBAvailable;
};
